import { PayPalScriptOptions } from '@paypal/paypal-js'

export const initialOptions: PayPalScriptOptions = {
    clientId: '',
    currency: 'USD',
    dataClientToken: '',
    components: 'buttons,messages,marks,funding-eligibility',
}
